import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { debounceTime, map, mergeMap, Subject, take } from "rxjs";
import { XchangeSearchControlService } from "./xchange-search-control.service";

@Component({
  selector: 'xchange-search-control',
  templateUrl: './xchange-search-control.component.html',
  styleUrl: './xchange-search-control.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => XchangeSearchControlComponent),
    },
  ],
})
export class XchangeSearchControlComponent implements OnInit, OnChanges  {

  @ViewChild("searchBoxInput") searchBoxInput!: ElementRef<any>;
  @Input("disabled") disabled: boolean = false;
  @Input("placeholder") placeholder: string = "";
  @Input("value") value: string = "";
  @Input("isGlobalSearchEnabled") isGlobalSearchEnabled: Boolean = true;
  @Output() change: EventEmitter<string> = new EventEmitter<string>();
  @Output() input: EventEmitter<string> = new EventEmitter<string>();
  @Output() blur: EventEmitter<string> = new EventEmitter<string>();
  @Output() keypress: EventEmitter<string> = new EventEmitter<string>();
  @Output() keydown: EventEmitter<string> = new EventEmitter<string>();
  @Output() keyup: EventEmitter<string> = new EventEmitter<string>();
  @Output() sendValue: EventEmitter<string> = new EventEmitter<string>();
  @Output() focus: EventEmitter<any> = new EventEmitter<any>();
  @Input() searchByIcon = false;
  @Input() searchFlag: boolean = false;
  clearFlag: boolean = false;
  searchDefaultValue: string = "";
  searchCurrentPage = 0;
  searchResultFields = "GSVIEW";
  searchResultsPageSize = 20;
  suggestionsFields = "DEFAULT";
  suggestionMaxSize = 10;
  filteredProducts: any = [];
  @Input() searchKey: any = "";
  subject = new Subject();
  showSpinner = false;
  showDropdown = false;
  constructor(
    private xchangeSearchControlService: XchangeSearchControlService,
    private router: Router
  ) {}

  onChange = (_: any) => {};
  onTouch = (_: any) => {};

  writeValue(value: string): void {
    this.searchDefaultValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  postModificationFlag: boolean = false;
  orderNumber: any;

  ngOnInit(): void {
    let _this = this;
    if (this.value) this.searchDefaultValue = this.value;
    window.addEventListener("click", function (e: any) {
      if (document.getElementById("product-dropDown")?.contains(e.target)) {
      } else {
        if (_this.filteredProducts.length) _this.filteredProducts = [];
      }
    });

    this.subject.pipe(debounceTime(500)).subscribe((searchText) => {
      if (searchText) this.getListOfProducts();
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.disabled && this.searchKey.length > 0) {
      this.searchKey = "";
    }
  }

  onClearInput() {
    this.searchKey = "";
    this.searchDefaultValue = "";
    this.searchBoxInput.nativeElement.value = "";
    this.input.emit(this.searchDefaultValue);
    this.sendValue.emit("");
    this.filteredProducts = [];
    this.focus.emit("");
    this.clearFlag = false;
  }
  onchange(event: Event) {
    if (!this.searchByIcon) {
      this.sendValue.emit(this.searchKey);
    }
  }

  onInputEvent(event: Event) {
    if (this.isGlobalSearchEnabled) {
      if (!this.searchByIcon) {
        this.searchDefaultValue =
          (event.target as HTMLInputElement).value || "";
        this.onChange(this.searchBoxInput);
        this.input.emit(this.searchDefaultValue);
        this.filteredProducts = [];
        if (this.searchDefaultValue.length >= 1) {
          if (this.isGlobalSearchEnabled) {
            this.subject.next(this.searchDefaultValue);
          }
        }
      }
    }
  }

  getListOfProducts() {
    this.showSpinner = true;
    this.showDropdown = true;
    this.xchangeSearchControlService
      .searchResults(
        this.searchCurrentPage,
        this.searchResultFields,
        this.searchResultsPageSize,
        this.searchKey
      )
      .subscribe(
        (res: any) => {
          this.showSpinner = false;
          if (res.products == undefined) {
            this.filteredProducts = [];
          } else this.filteredProducts = res.products;
        },
        (err) => {
          this.showSpinner = false;
        }
      );
  }

  onSuggestionClick(productId: any) {
    if (this.router.url.split("/")[2] == "post-modification") {
      this.postModificationFlag = true;
    } else {
      this.postModificationFlag = false;
    }
    if (this.postModificationFlag) {
      const url = this.router.url.split("?")[0];
      this.orderNumber = url.split("/")[4];
    }
    this.onClearInput();
    let navigateUrl = "";
    if (productId.substring(0, 1) === "R") {
      if (this.postModificationFlag) {
        navigateUrl =
          "/residential/post-modification/products/details/" +
          this.orderNumber +
          "/" +
          productId;
      } else {
        navigateUrl = "/residential/products/details/" + productId;
      }
    }
    if (productId.substring(0, 1) === "C") {
      if (this.postModificationFlag) {
        navigateUrl =
          "/commercial/post-modification/products/details/" +
          this.orderNumber +
          "/" +
          productId;
      } else {
        navigateUrl = "/commercial/products/details/" + productId;
      }
    }
    
    let compInstance = document.getElementsByTagName("app-pdp");
    if (compInstance.length > 0) {
      this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
        this.router.navigateByUrl(navigateUrl);
        this.showDropdown = false;
      });
    } else {
      this.router.navigateByUrl(navigateUrl);
      this.filteredProducts = [];
    }
  }

  onBlurEvent(event: Event) {
    if (!this.searchByIcon) {
      this.searchDefaultValue = (event.target as HTMLInputElement).value || "";
      this.blur.emit(this.searchDefaultValue);
    }
  }

  onKeypress(event: Event) {
    if (!this.searchByIcon) {
      this.searchDefaultValue = (event.target as HTMLInputElement).value || "";
      this.keypress.emit(this.searchDefaultValue);
    }
  }

  onKeydown(event: Event) {
    if (this.isGlobalSearchEnabled) {
      this.searchDefaultValue = (event.target as HTMLInputElement).value || "";
      if (!this.searchByIcon) {
        this.keypress.emit(this.searchDefaultValue);
      }
    }
  }

  onKeyup(event: Event) {
    if (this.isGlobalSearchEnabled) {
      if (!this.searchByIcon) {
        this.searchDefaultValue =
          (event.target as HTMLInputElement).value || "";
        this.keyup.emit(this.searchDefaultValue);
      }
    }
  }

  onEnter() {
    if (this.searchKey.length > 0) {
      if (this.isGlobalSearchEnabled) {
        this.navigateToPlp();
      } else if(this.searchKey.length > 2){
        this.sendValue.emit(this.searchKey);
      }
    }
  }

  onSearch() {
    this.focus.emit("");
    this.sendValue.emit(this.searchKey);
    if (this.searchKey.length > 2) {
      if (this.isGlobalSearchEnabled) {
        this.navigateToPlp();
      }
    }
  }

  navigateToPlp() {
    if (this.searchKey.length > 0) {
      let navigatePLPUrl = `/products?search=${this.searchKey}`;
      if (this.router.url?.split("?")[0].includes("residential")) {
        navigatePLPUrl = "/residential" + navigatePLPUrl;
      } else if (this.router.url?.split("?")[0].includes("commercial")) {
        navigatePLPUrl = "/commercial" + navigatePLPUrl;
      }
      this.filteredProducts = [];
      this.searchKey = "";
      this.router.navigateByUrl(navigatePLPUrl);
    }
  }
  onFocus() {
    this.focus.emit("");
  }
}
